import { Action } from '@thoughtspot/visual-embed-sdk'

import { type Enum } from '@webapp/utils'

export const ThoughtSpotActions = {
  ...Action,
  NavigateToLinkOut: 'navigate-to-link-out',
} as const
export type ThoughtSpotAction = Enum<typeof ThoughtSpotActions>
